import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import { useResources } from '@/contexts/resource-context';
import { PublishDialogFormInput } from '@/features/canvas/components/PublishDialogFormInput';
import { PUBLIC_LINK_TITLE_MAX_LENGTH } from '@/features/canvas/constants';

const PublishDialogFormContent = () => {
  const { resources } = useResources();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        justifyContent: 'space-between',
        marginBottom: '3rem',
      }}
    >
      <PublishDialogFormInput
        name="title"
        label={t('editor.header.publish_dialog.roadmap_title')}
        placeholder={t('editor.header.publish_dialog.roadmap_title_placeholder')}
        rules={{
          required: { value: true, message: t('form.field_required_validation') },
          maxLength: {
            value: PUBLIC_LINK_TITLE_MAX_LENGTH,
            message: t('form.field_too_long'),
          },
        }}
        size="small"
      />
      {!resources.is_sso && (
        <PublishDialogFormInput
          name="password"
          type="password"
          label={t('editor.header.publish_dialog.set_password')}
          placeholder={t('editor.header.publish_dialog.password_placeholder')}
          rules={{
            required: { value: true, message: t('form.field_required_validation') },
            minLength: {
              value: 8,
              message: t('authentication.wrong_password_length', { maxCharCount: 8 }),
            },
          }}
          size="small"
        />
      )}
    </Box>
  );
};

export { PublishDialogFormContent };
